export const maskString = (string, startMaskingIndex, endMaskingIndex) => {
  const stringToMask = `${string}`;

  return stringToMask.replace(stringToMask.slice(startMaskingIndex, endMaskingIndex || stringToMask.length), ' **** ')
};